const RANKING = [
  {
    rank: 1,
    title: '暗夜猎魔人：觉醒',
    type: '国漫',
    hot: '9.8分',
    trend: 'up',
    viewers: '128万人在读',
    img: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20cover%20with%20warrior%20character%20battle%20scene%2C%20dramatic%20lighting%20with%20orange%20and%20red%20tones%2C%20Chinese%20manhua%20style%2C%20dynamic%20action%20pose%2C%20simple%20background&width=400&height=533&seq=rank-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '霸道总裁的契约新娘',
    type: '韩漫',
    hot: '9.7分',
    trend: 'up',
    viewers: '115万人在读',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20romance%20manga%20cover%20with%20couple%20in%20formal%20attire%2C%20Korean%20webtoon%20aesthetic%2C%20soft%20pink%20tones%2C%20romantic%20luxury%20atmosphere%2C%20clean%20simple%20background&width=400&height=533&seq=rank-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '狐妖大人请留步',
    type: '国漫',
    hot: '9.6分',
    trend: 'up',
    viewers: '98万人在读',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20manga%20cover%20with%20fox%20spirit%20in%20hanfu%2C%20misty%20mountain%20background%2C%20warm%20golden%20and%20red%20tones%2C%20Chinese%20manhua%20art%20style%2C%20mystical%20elegant%20atmosphere&width=400&height=533&seq=rank-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '青梅竹马是吸血鬼',
    type: '日漫',
    hot: '9.5分',
    trend: 'stable',
    viewers: '87万人在读',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20supernatural%20manga%20cover%20with%20mysterious%20atmosphere%2C%20Japanese%20manga%20style%2C%20dark%20crimson%20and%20purple%20tones%2C%20cherry%20blossom%20petals%2C%20clean%20composition&width=400&height=533&seq=rank-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '秘密花园的秘密',
    type: '韩漫',
    hot: '9.4分',
    trend: 'up',
    viewers: '76万人在读',
    img: 'https://readdy.ai/api/search-image?query=Gentle%20slice%20of%20life%20manga%20cover%20with%20beautiful%20garden%20scene%2C%20Korean%20webtoon%20style%2C%20soft%20pastel%20green%20tones%2C%20warm%20sunlight%2C%20healing%20peaceful%20atmosphere&width=400&height=533&seq=rank-05&orientation=portrait',
  },
  {
    rank: 6,
    title: '重生之商业帝国',
    type: '韩漫',
    hot: '9.3分',
    trend: 'down',
    viewers: '72万人在读',
    img: 'https://readdy.ai/api/search-image?query=Modern%20business%20drama%20manga%20cover%2C%20professional%20character%20in%20suit%20with%20cityscape%2C%20Korean%20webtoon%20style%2C%20cool%20blue%20gray%20tones%2C%20elegant%20clean%20composition&width=400&height=533&seq=rank-06&orientation=portrait',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门排行
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全网<strong>好看的漫画</strong>人气排行，发现最受欢迎的<strong>免费漫画</strong>
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {RANKING.map((item) => (
            <a
              key={item.rank}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`虫虫漫画网排行 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-primary-500 text-background-50 font-bold text-xs md:text-sm rounded-br-lg">
                  {item.rank}
                </div>
                {item.trend === 'up' && (
                  <div className="absolute top-0 right-0 w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-accent-500">
                    <i className="ri-arrow-up-fill text-sm"></i>
                  </div>
                )}
                {item.trend === 'down' && (
                  <div className="absolute top-0 right-0 w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-foreground-400">
                    <i className="ri-arrow-down-fill text-sm"></i>
                  </div>
                )}
              </div>
              <div className="p-3">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-900 font-heading line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-1.5 flex items-center justify-between">
                  <span className="text-[10px] text-foreground-500">{item.type}</span>
                  <span className="text-[10px] text-accent-600 font-medium">{item.hot}</span>
                </div>
                <p className="mt-1.5 text-[10px] text-foreground-500">{item.viewers}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}